module.exports = __webpack_public_path__ + "nc.svg?4a81364ae474c4e86ae312475a7c7e6e";